import React, { useEffect, useState } from 'react'
import { Error, LoadingSpinner } from '../../components'
import auth0, { getBrowseRedirectUri } from '../../utils/auth0'
import { newRelicTriggerErrorEvent } from '../../utils/newrelic'

type Props = {
  location: {
    search: string
  }
}

export default function BrowseLogin({ location: { search } }: Props): JSX.Element {
  const [error, setError] = useState<{ code: string } | null>(null)

  useEffect(() => {
    ;(async () => {
      try {
        const params = new URLSearchParams(search)
        const initialScreen = params.get('initialScreen')
        const redirectUri = getBrowseRedirectUri(search)
        await auth0().loginWithRedirect({
          redirect_uri: redirectUri,
          ...(initialScreen && { initialScreen }),
        })
      } catch (error) {
        console.error(error)
        newRelicTriggerErrorEvent('browse-login', error)
        setError({ code: 'browse.login.error' })
      }
    })()
  }, [])

  return <div data-test="browse-login">{error ? <Error /> : <LoadingSpinner />}</div>
}
